import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET } from "./apiRoutes";

interface UseGetBudgetLogProps {
  communityId: string;
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

// Everything recorded for this budget and the other versions in its revision chain, newest first
const getBudgetLog = async (communityId: string, budgetId: string) =>
  await axiosAuth.get(`${BUDGET(communityId)}/${budgetId}/log`);

const useGetBudgetLog = ({
  queryParams,
  communityId,
  budgetId,
}: UseGetBudgetLogProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["budget-log", communityId, budgetId],
    queryFn: () => getBudgetLog(communityId, budgetId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!budgetId && (queryParams?.enabled ?? true),
  });
};

export default useGetBudgetLog;
